import React from "react";
import { authApi } from "../../apis";
import { SCREEN_PATHS } from "../../constants";

export const SignOut = (): JSX.Element => {
  const signOut = async () => {
    await authApi.signOut();
    window.location.href = SCREEN_PATHS.auth;
  };

  signOut();

  return <></>;
};
